import { Fragment, FC, memo } from "react"
import { escapeRegExp } from "lodash"

export interface IHighlighterProps {
    text: string
    highlight: string | string[]
}

const Highlighter: FC<IHighlighterProps> = ({
    text,
    highlight
}) => {
    const highlightParts = (
            highlight instanceof Array
                ? highlight.map(p => p.trim())
                : [highlight.trim()]
        ).filter(p => !!p).map(p=>p.toLowerCase())

    if (!text.trim()
        || highlightParts.length === 0
        || highlightParts.every(p => !p)) {
        return <>{text}</>
    }

    const regex = new RegExp(`(${highlightParts.map(p => escapeRegExp(p)).join("|")})`, "gi")
    const parts = text.split(regex)

    return (
        <>
            {parts
                .filter(p => !!p)
                .map((part, i) => (
                    highlightParts.includes(part.toLowerCase())
                        ? <strong key={i}>{part}</strong>
                        : <Fragment key={i}>{part}</Fragment>
                ))
            }
        </>
    )
}

export default memo(Highlighter)
